import { Skeleton } from "@/components/ui/skeleton";

export default function ListSkeleton({ rows = 5, className = "" }) {
  return (
    <div className={`divide-y divide-border/60 ${className}`} data-testid="list-skeleton">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-4 px-5 py-4" style={{ opacity: 1 - i * 0.12 }}>
          <Skeleton className="h-10 w-10 rounded-xl" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-3.5 w-1/3" />
            <Skeleton className="h-3 w-1/2" />
          </div>
          <Skeleton className="h-6 w-24 rounded-full" />
          <Skeleton className="h-8 w-28 rounded-lg hidden sm:block" />
        </div>
      ))}
    </div>
  );
}
